import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';
import { ButtonV2, type ButtonV2Props } from '../button-v2/button-v2.tsx';
import { CardV2 } from '../card-v2/card-v2.tsx';
import { FollowersV2 } from '../followers-v2/followers-v2.tsx';
import { HandleV2, type HandleV2Props } from '../handle-v2/handle-v2.tsx';
import { ArrowRightIcon } from '../icons/react/arrow-right.tsx';
import { StarIcon } from '../icons/react/star.tsx';
import {
  PriceTagV2,
  type PriceTagV2Price,
} from '../price-tag-v2/price-tag-v2.tsx';
import {
  streamRowV2,
  streamRowV2Copy,
  streamRowV2Description,
  streamRowV2Featured,
  streamRowV2Handle,
  streamRowV2Meta,
  streamRowV2Title,
  streamRowV2View,
} from './stream-row-v2.css.ts';

export const StreamRowV2 = ({
  className,
  ...rest
}: ComponentPropsWithoutRef<'div'>) => (
  <CardV2
    className={clsx(streamRowV2, className)}
    {...rest}
    hoverable
    data-testid="stream-row-v2"
  />
);

export const StreamRowV2Copy = ({
  title,
  description,
  className,
}: {
  title: string;
  description?: string | null;
  className?: string;
}) => (
  <div className={clsx(streamRowV2Copy, className)}>
    <p className={streamRowV2Title}>{title}</p>
    {description ? (
      <p className={streamRowV2Description}>{description}</p>
    ) : null}
  </div>
);

export type StreamRowV2MetaProps = {
  featured: boolean;
  price: PriceTagV2Price;
  followers: string;
  handle: string;
  avatarSrc?: string | null;
  renderHandle?: HandleV2Props['render'];
  onView?: ButtonV2Props['onClick'];
  className?: string;
};

export const StreamRowV2Meta = ({
  featured,
  price,
  followers,
  handle,
  avatarSrc,
  renderHandle,
  onView,
  className,
}: StreamRowV2MetaProps) => (
  <div className={clsx(streamRowV2Meta, className)}>
    <span
      className={streamRowV2Featured}
      data-testid={featured ? 'stream-row-featured-v2' : undefined}
      aria-hidden
    >
      {featured ? <StarIcon /> : null}
    </span>
    <div className={streamRowV2Handle}>
      <HandleV2 handle={handle} avatarSrc={avatarSrc} render={renderHandle} />
    </div>
    <FollowersV2 count={followers} />
    <PriceTagV2 price={price} />
    <ButtonV2
      variant="secondary"
      className={streamRowV2View}
      endIcon={<ArrowRightIcon />}
      onClick={onView}
    >
      View
    </ButtonV2>
  </div>
);
